/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Move_SubtitleInputs */



/**
* | output |
* | --- |
* | "Select one or more gateways to move on the plan" |
*
* @param {Gateway_Move_SubtitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const gateway_move_subtitle = /** @type {((inputs?: Gateway_Move_SubtitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Move_SubtitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Select one or more gateways to move on the plan")
	return /** @type {LocalizedString} */ ("Sélectionnez une ou plusieurs box à déplacer sur le plan")
});